import React from 'react';


export default (props) => {
  
    const {
        colorFlows
    }= props

    const typesFlows = [
        'Target page',
        'External link',
        'Service request'
    ];
   
    return (
        <aside
            style={{
                position: 'absolute',
                right: 10,
                top: 10,
                zIndex: 4,
                textTransform: 'none',
                borderStyle: 'solid',
                borderRadius: '0.5vw',
                borderWidth: '1px',
            }}
        >
            <div className="description" style={{justifyContent: 'center', display: 'flex', fontSize: '1vw'}}>
                Action types
            </div>
            <hr style={{color: 'black', height: '1px', backgroundColor: 'black'}}/>
            <div style={{marginTop: '0.4vw', marginLeft: '0.4vw', marginRight: '0.4vw', marginBottom: '0.4vw'}}>

                {
                    typesFlows.map( (type, index) => 
                        <div key={`SideBarOption${type}`} style={{display: 'flex', flexDirection: 'row',lineHeight : '1vw', paddingBottom: '0.4vw' }}>
                            <div style={{backgroundColor: colorFlows[index], width: '1vw',height: '1vw'  }}/>  &nbsp;   
                            <div > {type}</div>
                        </ div>
                    )

                } 
            </div>
        </aside>
    );
};